import React from "react"
import PropTypes from "prop-types"
import { Divider, Flex, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { numberToCurrency } from "helpers/string"
import { useTranslation } from "react-i18next"
import { Title, Text } from "ui/Typography"
import styles from "./index.module.css"
import { spacings } from "themes/variables"

const FlatRatePriceTooltip = ({
    pricing_type,
    included_guests,
    guests_included_in_flat_rate,
    price_per_person,
    price_per_child,
    price_per_infant
}) => {
    const { t } = useTranslation()
    if (pricing_type !== "charge_flat_rate") return null
    const included = included_guests ?? guests_included_in_flat_rate ?? 0

    const renderTooltipContent = () => {
        const extraGuestPrices = []
        if (Number(price_per_person) > 0) extraGuestPrices.push(`${numberToCurrency(price_per_person)}/adult`)
        if (Number(price_per_child) > 0) extraGuestPrices.push(`${numberToCurrency(price_per_child)}/child`)
        if (Number(price_per_infant) > 0) extraGuestPrices.push(`${numberToCurrency(price_per_infant)}/infant`)

        return (
            <Flex vertical gap={spacings.XXS} className={styles.tooltipContent}>
                <Title level={4}>{t("client.payment.tooltip.price_details")}</Title>
                <Divider style={{ borderColor: `var(--color-surface2)` }} />
                <Text size="lg" className="mb-xs">{t("client.payment.tooltip.guests_included", { count: included })}</Text>
                {extraGuestPrices.length > 0 && (
                    <Flex gap={spacings.XXS} vertical>
                        <Text size="lg">{t("client.payment.tooltip.additional_guests")}</Text>
                        {extraGuestPrices.map((price, idx) => (
                            <Text key={`${price}-${idx}`} size="lg">
                                {price}
                            </Text>
                        ))}
                    </Flex>
                )}
            </Flex>
        )
    }

    return (
        <Tooltip title={renderTooltipContent()}>
            <InfoCircleOutlined className="ml-xxs" style={{ fontSize: 16, color: "var(--color-primary)" }} />
        </Tooltip>
    )
}

FlatRatePriceTooltip.propTypes = {
    pricing_type: PropTypes.string,
    included_guests: PropTypes.number,
    guests_included_in_flat_rate: PropTypes.number,
    price_per_person: PropTypes.number,
    price_per_child: PropTypes.number,
    price_per_infant: PropTypes.number
}

export default FlatRatePriceTooltip
